import { useMutation } from "@tanstack/react-query";
import { startTrial } from "api-client";
import { useTranslation } from "react-i18next";
import { useToast } from "ui";

import { clearBillingProductSelection } from "src/helpers/billingSelection";

export function useStartTrial() {
  const toast = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (params: { billingProductId: string }) => {
      const response = await startTrial({
        body: { billingProductId: params.billingProductId },
      });
      return response.data.data;
    },
    onSuccess: () => {
      clearBillingProductSelection();
      window.location.reload();
    },
    onError: (error) => {
      toast.toast({
        title: t("planChooser.startTrialError"),
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
